type LogLevel = 'error' | 'warn' | 'info' | 'debug';

const isProduction = import.meta.env.PROD;

function formatMessage(level: LogLevel, message: string, context?: Record<string, unknown>): string {
  const timestamp = new Date().toISOString();
  const contextStr = context ? ` ${JSON.stringify(context)}` : '';
  return `[${timestamp}] [${level.toUpperCase()}] ${message}${contextStr}`;
}

export const logger = {
  error(message: string, context?: Record<string, unknown>) {
    console.error(formatMessage('error', message, context));
    // Future: Send to Sentry here
  },
  warn(message: string, context?: Record<string, unknown>) {
    console.warn(formatMessage('warn', message, context));
  },
  info(message: string, context?: Record<string, unknown>) {
    if (!isProduction) {
      console.info(formatMessage('info', message, context));
    }
  },
  debug(message: string, context?: Record<string, unknown>) {
    if (!isProduction) {
      console.debug(formatMessage('debug', message, context));
    }
  },
};

export default logger;
